var generateStyle = function generateStyle(componentTheme) {
  return {
    addToBank: {
      backgroundColor: componentTheme.addToBankBackgroundColor,
      border: "1px dashed ".concat(componentTheme.addToBankBorderColor),
      textAlign: 'center'
    }
  };
};
export default generateStyle;